export default {
  namespaced: true,
  state: () => ({
    loadingRedButton: false,
    loadingSubmitButton: false,
    loadingSubmitButton2: false,
  }),

  getters: {
    getLoadingRedButton: (state) => state.loadingRedButton,
    getLoadingSubmitButton: (state) => state.loadingSubmitButton,
    getLoadingSubmitButton2: (state) => state.loadingSubmitButton2,
  },
  mutations: {
    SET_LOADING_RED_BUTTON(state, value) {
      state.loadingRedButton = value;
    },
    SET_LOADING_SUBMIT_BUTTON(state, value) {
      state.loadingSubmitButton = value;
    },
    SET_LOADING_SUBMIT_BUTTON2(state, value) {
      state.loadingSubmitButton2 = value;
    },
  },
  actions: {
    setLoadingRedButton({ commit }, value) {
      commit("SET_LOADING_RED_BUTTON", value);
    },
    setLoadingSubmitButton({ commit }, value) {
      commit("SET_LOADING_SUBMIT_BUTTON", value);
    },
    setLoadingSubmitButton2({ commit }, value) {
      commit("SET_LOADING_SUBMIT_BUTTON2", value);
    },
  },
};
